import FleetManagementDashboard from "./FleetManagementDashboard";

export default FleetManagementDashboard;